import React, { ReactNode } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Menu from "../menu";
import { useLocation } from "react-router-dom";

interface IWrapperProps {
  children: ReactNode;
}

export default function Wrapper({ children }: IWrapperProps) {
  const location = useLocation();

  const isNoContainer = location.pathname.includes("/statistic-dashboard");
  const isQRIframe = location.pathname.match(/\/entry\/(\d+)/);
  const isPayment = location.pathname.includes("/payment");
  const isSupport = location.pathname.includes("/support");

  return (
    <Container fluid className="gx-0 text-dark">
      <Row className="gx-0 h-100">
        <Col xs={12} lg={3} xxl={2} className="text-gray">
          <Menu />
        </Col>
        <Col
          lg={9}
          xxl={10}
          xs={12}
          className={`bg-additional-gray col-10 overflow-auto scroll-none mx-auto${!isNoContainer ? " pt-5 pt-md-0" : ""}`}
          style={{ minHeight: "100vh" }}
        >
          {isNoContainer ? (
            children
          ) : (
            <div
              className={`${!isQRIframe && `${!isSupport && "container-paddings"} ${!isPayment && "container"}`} scroll-none pb-4 pt-5 py-md-5`}
            >
              {children}
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
}
